import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Stack, Typography } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { useState } from 'react'
import { bookingType1, chargeType1, fixedCharge } from '../../GSConstants'
import { PaymentTypesOptions } from '../../../../common/constants'
import Lineinput from '../../../../common/lineinput'
import { updateDemurrageChrg } from '../../../../../store/generalSetting/GSAction'
import * as mdt from '../../../../common/modaltypes'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { focusElemnt, isNull, navigation1, navigation3 } from '../../../../common/helper'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const DemurrageChrgModal = (props) => {
  const {
    data: { common },
    updateModal,
    updateAlertError,
    getDemurrageChrg,
    updateDemurrageChrg,UseToPayAsCOD
  } = props
  const { loginData, cnsgnmntTypes } = common
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const translatedFixedCharge = fixedCharge.map((item) => ({
    ...item,
    name: tr(item.translationKey, item.name),
  }))
  const translatedChargeTypes = chargeType1.map((item) => ({
    ...item,
    name: tr(item.translationKey, item.name),
  }))
  const translatedBookingTypes = bookingType1.map((item) => ({
    ...item,
    name: tr(item.translationKey, item.name),
  }))
  const consignmentTypesWithAll = cnsgnmntTypes.length > 0
    ? [{ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') }, ...cnsgnmntTypes]
    : []
  const paymentTypeOptions = PaymentTypesOptions.map((item) => {
    if (item.id === 0) {
      return { ...item, Name: tr('gsAll', 'All') }
    }
    if (UseToPayAsCOD === 1) {
      if (item.id === 2) {
        return { ...item, Name: 'COD' };
      }
      if (item.id === 7) {
        return { ...item, Name: 'COD Manual' };
      }
      if (item.id === 9) {
        return { ...item, Name: 'COD DDDV' };
      }
      if (item.id === 4) {
        return null;
      }
    }
    return item;
  }).filter(Boolean)
  const { propsData, getDemurrageChrgList } = props
  const { headText, isUpdate, existingData } = propsData
  const [selConsignmentType, setSelConsignmentType] = useState({})
  const [selBookingType, setSelBookingType] = useState({})
  const [selChargeType, setSelChargeType] = useState({})
  const [selPaymentType, setSelPaymentType] = useState({})
  const [selFixChrg, setSelFixChrg] = useState(fixedCharge[0])
  const [afterDyas, setAfterDyas] = useState(0)
  const [demmurageChrg, setDemmurageChrg] = useState(0)
  const [isMaxDemurrageChrg, setIsMaxDemurrageChrg] = useState(true)
  const [isActive, setIsActive] = useState(false)
  const [maxDemmurageChrg, setMaxDemmurageChrg] = useState(0)

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('addEdit_Booking_Type')
  }, [])
  useEffect(() => {
    setSelFixChrg((prev) =>
      translatedFixedCharge.find((item) => item.id === prev?.id) || translatedFixedCharge[0]
    )
    setSelChargeType((prev) =>
      prev?.id != null
        ? translatedChargeTypes.find((item) => item.id === prev.id) || prev
        : prev
    )
    setSelBookingType((prev) =>
      prev?.id != null
        ? translatedBookingTypes.find((item) => item.id === prev.id) || prev
        : prev
    )
    setSelConsignmentType((prev) =>
      prev?.ConsignmentSubTypeID === 0 ? consignmentTypesWithAll[0] || prev : prev
    )
    setSelPaymentType((prev) => prev?.id === 0 ? paymentTypeOptions.find((item) => item.id === 0) || prev : prev)
  }, [translations])
  useEffect(() => {
    if (isUpdate) {
      setSelBookingType(translatedBookingTypes.find((item) => item.id === 1) || { id: 1, name: 'Own Bookings', translationKey: 'gsOwnBkg' })
      setSelChargeType(translatedChargeTypes.find((item) => item.id === existingData?.ChargeTypeID) || { id: existingData?.ChargeTypeID, name: existingData?.ChargeTypeDesc })
      setSelConsignmentType(
        existingData?.ConsignmentSubTypeID === 0
          ? consignmentTypesWithAll[0] || { ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') }
          : { ConsignmentSubTypeID: existingData?.ConsignmentSubTypeID, SubType: existingData?.SubType }
      )
      setSelPaymentType(
        existingData?.PayTypeID === 0
          ? paymentTypeOptions.find((item) => item.id === 0) || { id: 0, Name: tr('gsAll', 'All') }
          : { id: existingData?.PayTypeID, Name: existingData?.PaymentType }
      )
      setSelFixChrg(
        translatedFixedCharge.find((item) => item.id === (existingData?.IsFixed === 'NO' ? 0 : 1)) || translatedFixedCharge[0]
      )
      setAfterDyas(existingData?.AfterDays)
      setDemmurageChrg(existingData?.DemurrageCharge)
      setIsMaxDemurrageChrg(existingData?.IsMaxDemurrageChg === 'NO' ? false : true)
      setIsActive(existingData?.IsActive === 1 ? true : false)
      setMaxDemmurageChrg(existingData?.MaxDemurrageChg)
    }
  }, [isUpdate])

  const handleSaveAndUpdateDemurrageChrg = () => {
    let allConsignmentIds, commaSeparatedConsignmentIds, allPaymentIds, commaSeparatedPaymentIds
    if (selConsignmentType?.ConsignmentSubTypeID === 0) {
      allConsignmentIds = cnsgnmntTypes?.map((item) => item.ConsignmentSubTypeID)
      commaSeparatedConsignmentIds = allConsignmentIds.join(', ')
    }
    if (selPaymentType?.id === 0) {
      allPaymentIds = PaymentTypesOptions?.map((item) => item.id)
      commaSeparatedPaymentIds = allPaymentIds.join(', ')
    }
    const body = {
      CompanyID: loginData?.intCompanyID,
      UserID: loginData?.intUserID,
      ConsignmentType:
        selConsignmentType?.ConsignmentSubTypeID === 0
          ? commaSeparatedConsignmentIds
          : (selConsignmentType?.ConsignmentSubTypeID).toString(),
      PayTypeID: selPaymentType?.id === 0 ? commaSeparatedPaymentIds : (selPaymentType?.id).toString(),
      DemurrageCharge: demmurageChrg,
      IsActive: isActive ? 1 : 0,
      DemChargeType: selChargeType?.id,
      Days: afterDyas,
      IsFixed: selFixChrg?.id,
      Mode: selBookingType?.id,
      IsMaxDemChgSet: isMaxDemurrageChrg ? 1 : 0,
      MaxDemurrageChg: maxDemmurageChrg,
    }
    updateDemurrageChrg(body)
      .then((res) => {
        if (res.status === 'Success') {
          updateModal(true, mdt.demurrageChrgConfModal)
          getDemurrageChrgList()
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  return (
    <Modal
      headTxt={headText}
      width={'60%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Stack className="GSConsTypeModal" style={{ padding: '16px' }}>
        <Grid container style={{ padding: '0px', justifyContent: 'space-between' }}>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              key={`booking-type-${language}-${selBookingType?.name}`}
              id={'addEdit_Booking_Type'}
              label={tr('gsBookType', 'Booking Type')}
              data={translatedBookingTypes}
              defaultvalue={selBookingType?.name}
              idKey={`id`}
              dataKey={`name`}
              width="100%"
              nextId={'addEdit_Charge_Type'}
              onSelect={(val) => {
                setSelBookingType(val)
              }}
            />
          </Grid>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              key={`charge-type-${language}-${selChargeType?.name}`}
              id={'addEdit_Charge_Type'}
              label={tr('gsChgType', 'Charge Type')}
              data={translatedChargeTypes}
              idKey={`id`}
              dataKey={`name`}
              defaultvalue={selChargeType?.name}
              width="100%"
              nextId={'addEdit_Consignment_Type'}
              prevId={`addEdit_Booking_Type`}
              onSelect={(val) => {
                setSelChargeType(val)
              }}
            />
          </Grid>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              key={`consignment-type-${language}-${selConsignmentType?.SubType}`}
              id={'addEdit_Consignment_Type'}
              label={tr('gsSelCnsType', 'Select Consignment Type')}
              // data={cnsgnmntTypes}
              data={consignmentTypesWithAll}
              defaultvalue={selConsignmentType?.SubType}
              value={selConsignmentType?.SubType}
              onSelect={(val) => {
                setSelConsignmentType(val)
              }}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              width="100%"
              prevId={`addEdit_Charge_Type`}
              nextId={'addEdit_Payment_Type'}
            />
          </Grid>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              key={`payment-type-${language}-${selPaymentType?.Name}`}
              id={'addEdit_Payment_Type'}
              label={tr('gsPayType', 'Payment Type')}
              // data={PaymentTypesOptions}
              data={paymentTypeOptions}
              defaultvalue={selPaymentType?.Name}
              value={selPaymentType?.Name}
              dataKey={`Name`}
              idKey={`id`}
              width="100%"
              nextId={'fixed_charge'}
              prevId={`addEdit_Consignment_Type`}
              onSelect={(val) => {
                setSelPaymentType(val)
              }}
            />
          </Grid>
        </Grid>
      </Stack>
      <Stack className="GSConsTypeModal" style={{ padding: '16px' }}>
        <Grid container style={{ padding: '0px' }}>
          <Grid item xs={6} md={2.6}>
            <Box sx={{ paddingLeft: '0px', paddingRight: '16px' }}>
              <DropDownOA
                key={`fixed_charge-${language}-${selFixChrg?.name}`}
                id="fixed_charge"
                defaultvalue={selFixChrg?.name}
                data={translatedFixedCharge}
                width="100%"
                searchPlaceholder={tr('gsSearchFixedChg', 'Search Fixed Charge')}
                label={tr('gsFixedChg', 'Fixed Charge')}
                dataKey={`name`}
                idKey={`id`}
                onSelect={(value) => setSelFixChrg(value)}
                nextId={'after_days'}
                prevId={'addEdit_Payment_Type'}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={2.6}>
            <Box sx={{ paddingLeft: '0px', paddingRight: '16px' }} className={'input--wrapper'}>
              <Lineinput
                id={'after_days'}
                label={tr('gsAfterDays', 'After Days')}
                type="text"
                name={tr('gsAfterDays', 'After Days')}
                value={afterDyas}
                sx={{ margin: '8px', width: '100%' }}
                onChange={(e) => setAfterDyas(e.target.value)}
                onKeyDown={(e) => navigation1(e, 'demurrage_chrg', 'fixed_charge')}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={2.6}>
            <Box sx={{ paddingLeft: '0px', paddingRight: '16px' }} className={'input--wrapper'}>
              <Lineinput
                id={'demurrage_chrg'}
                label={tr('gsDemChgLbl', 'Demurrage Charge')}
                type="text"
                name={tr('gsDemChgLbl', 'Demurrage Charge')}
                value={demmurageChrg}
                sx={{ margin: '8px', width: '100%' }}
                onChange={(e) => setDemmurageChrg(e.target.value)}
                onKeyDown={(e) => navigation1(e, 'is_max_demurrage_chrg', 'after_days')}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={3.0} style={{ marginLeft: 'auto' }}>
            <Box>
              <FormControlLabel
                id="is_max_demurrage_chrg"
                value="end"
                checked={isMaxDemurrageChrg}
                onChange={(e) => setIsMaxDemurrageChrg(!isMaxDemurrageChrg)}
                control={<Checkbox />}
                label={
                  <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px', margin: '0px' }}>
                    {tr('gsMaxDemChgLbl', 'Max. Demurrage Charge')}
                  </Typography>
                }
                labelPlacement="end"
                onKeyDown={(e) => navigation1(e, 'max_demurrage', 'demurrage_chrg')}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={1.1}>
            <Box sx={{ paddingX: '0px' }} className={'input--wrapper'}>
              <Lineinput
                id={'max_demurrage'}
                label={''}
                type="text"
                name=""
                value={maxDemmurageChrg}
                sx={{ margin: '8px', width: '100%' }}
                onChange={(e) => setMaxDemmurageChrg(e.target.value)}
                onKeyDown={(e) => navigation1(e, 'activeDemurrageCharge', 'is_max_demurrage_chrg')}
              />
            </Box>
          </Grid>
        </Grid>
      </Stack>
      <Divider />
      <Box sx={{ display: 'flex', justifyContent: 'end', padding: '16px' }}>
        <Item>
          <FormControlLabel
            id="activeDemurrageCharge"
            onChange={(e) => {
              setIsActive(e.target.checked)
            }}
            control={<Checkbox checked={isActive} />}
            label={
              <Typography variant="h6" sx={{ fontWeight: '600' }}>
                {tr('gsActDemChg', 'Active Demurrage Charge')}
              </Typography>
            }
            onKeyDown={(e) => navigation1(e, 'save_update_btn', 'max_demurrage')}
          />
        </Item>
        <Item className="disabled-wrapper" style={{ padding: '0px' }}>
          <Button
            id={'save_update_btn'}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
            onClick={handleSaveAndUpdateDemurrageChrg}
            onKeyDown={(e) => navigation3(e, 'addEdit_Booking_Type', 'activeDemurrageCharge', () => {})}
            disabled={
              Object.keys(selBookingType).length === 0 ||
              Object.keys(selChargeType).length === 0 ||
              Object.keys(selConsignmentType).length === 0 ||
              Object.keys(selPaymentType).length === 0
            }
          >
            {isUpdate ? tr('gsUpdate', 'UPDATE') : tr('gsSave', 'SAVE')}
          </Button>
        </Item>
      </Box>
    </Modal>
  )
}

//export default DemurrageChrgModal
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  updateAlertError,
  updateDemurrageChrg,
}

export default connect(mapStateToProps, mapDispatchToProps)(DemurrageChrgModal)
